/*****************************************************************************/
/*  File Name: leftBar.js                                                    */
/*  Date:      June 21, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the left hand bar of the roi calculator               */
/*             Handles the following forms                                   */
/*             - Clinic Name
/*             - Report Name
/*             - Calculator Type
/*             - System Select
/*             - Clinic Tax Braket
/*             - Add Financing?
/*             - Monthly Payment
/*             - Interest Rate on Loan
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
//import TextField from '@mui/material/TextField';
import styles from './styles/roi.module.scss';

import { useROIContext } from '../../context/roiContext';
import SystemSideBar from './systems';

import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { IconButton, MenuItem, Tooltip, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SettingsIcon from '@mui/icons-material/Settings';
import SoltaTextField from './elements/TextField';
import SoltaLargeTextField from './elements/LargeFontTextField';
import SoltaLargeWhiteTextField from './elements/LargeWhiteTextField';
import { convertToCurrency } from '../../functions/convertCurrency';
import { convertToNumber } from '../../functions/convertNumber';
import SoltaSelect from './elements/SelectField';
import * as MODE from '../../constants/modes';

function LeftBar({ t }) {
  //Load all of the default component varaibles

  const { roiLoading, roi, changeClinicName, changeReportsName, setClinicTaxBraket, clinicTaxBraket, addFinancing, setAddFinancing, monthlyPayment, setMonthlyPayment, interstRate, setinterestRate, drawerOpen, setDrawerOpen, roiMode, setROIMode, totalAnnualProfit, consumerAnnualTreatmenGrowthtProfit } = useROIContext();

  //console.log('this is my monthly payment ----> ', monthlyPayment);
  //console.log('this is my roi mode ---> ', roiMode);

  return (
    <>
      {!roiLoading ? (
        <div className={`${roiMode === MODE.upgrade ? styles.leftBarUpgrade: styles.leftBar} ${drawerOpen ? styles.formSection : styles.formClosed} `}>
          <div className={`${styles.clinicSection}  `}>
            <Grid item xs={12} container className={styles.clinicData}>
              <Grid item xs={12}>
                <SoltaTextField id='clinicName' onChange={(event) => changeClinicName(event.target.value)} value={roi.clinicName} label='Clinic Name' variant='standard' />
              </Grid>
              <Grid item xs={12}>
                <SoltaTextField id='reportName' onChange={(event) => changeReportsName(event.target.value)} value={roi.reportName} label='Report Name' variant='standard' />
              </Grid>
              <Grid item xs={12} container>
                <Grid item xs={12} className={styles.sectionTitle}>
                  Type of Report
                </Grid>
                <Grid item xs={12} className={styles.sectionCopy}>
                  <SoltaSelect labelId='roi-mode' id='roi-mode' value={roiMode} onChange={(event) => setROIMode(event.target.value)}>
                    <MenuItem value={MODE.capital}>{MODE.capital}</MenuItem>
                    <MenuItem value={MODE.consumer}>{MODE.consumer}</MenuItem>
                    <MenuItem value={MODE.upgrade}>{MODE.upgrade}</MenuItem>
                  </SoltaSelect>
                </Grid>
              </Grid>
              <SystemSideBar />
              {roiMode === MODE.capital ? (
                <Grid item xs={12}>
                  <SoltaLargeTextField
                    id='clinicTaxBraket'
                    InputProps={{
                      endAdornment: '%',
                    }}
                    onChange={(event) => setClinicTaxBraket(event.target.value)}
                    value={clinicTaxBraket}
                    label='Clinic Tax Bracket'
                    variant='standard'
                  />
                </Grid>
              ) : (
                ''
              )}
            </Grid>
            <div className={styles.closeSection}>
              <Grid item xs={12} container justifyContent='center' flexDirection='column' spacing={1}>
                <Grid item xs>
                  <Tooltip title={drawerOpen ? 'Hide Settings' : 'Show Settings'}>
                    <IconButton className={styles.closeButton} onClick={() => setDrawerOpen((previousState) => !previousState)}>
                      {drawerOpen ? <ArrowBackIosIcon className={`${styles.buttons} ${styles.backButton}`} /> : <ArrowForwardIosIcon className={`${styles.buttons} ${styles.backButton}`} />}
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item xs>
                  <SettingsIcon className={`${styles.buttons} ${styles.settingsButton}`} />
                </Grid>
              </Grid>
            </div>
          </div>
          <Grid item xs={12} container className={`${roiMode === MODE.upgrade ? styles.addFinanceBlockUpgrade: styles.addFinanceBlock}`}  >
            {roiMode === MODE.capital ? (
              <Grid item xs={12} className={styles.financeBlock}>
                <FormControl component='fieldset' className={styles.checkBoxGroup}>
                  <FormGroup aria-label='position' row className={styles.checkBoxGrid}>
                    <FormControlLabel
                      value='Add Financing?'
                      className={styles.checkBoxLabelGroup}
                      control={
                        <Checkbox
                          checked={addFinancing}
                          onChange={(event) => setAddFinancing(event.target.checked)}
                          sx={{
                            color: 'white',
                            '&.Mui-checked': {
                              color: 'white',
                            },
                          }}
                        />
                      }
                      label={<Typography className={styles.checkBoxLabel}>Add Financing?</Typography>}
                      labelPlacement='start'
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            ) : (
              ''
            )}

            {addFinancing ? (
              <Grid item xs={12} container className={styles.financeBlock}>
                <Grid item xs={12}>
                  <SoltaLargeWhiteTextField
                    InputProps={{
                      startAdornment: '$',
                    }}
                    id='monthlyPayment'
                    onChange={(event) => setMonthlyPayment(convertToNumber(event.target.value))}
                    value={convertToCurrency(monthlyPayment ?? 0)}
                    label='Monthly Payment'
                    variant='standard'
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <SoltaLargeWhiteTextField
                    id='interestRate'
                    InputProps={{
                      endAdornment: '%',
                    }}
                    onChange={(event) => setinterestRate(event.target.value)}
                    value={interstRate}
                    label='Interest Rate on Loan'
                    variant='standard'
                  />
                </Grid> */}
              </Grid>
            ) : null}

            {roiMode === MODE.upgrade ?
              <Grid item xs={12} container className={styles.profitDifferenceGroup}>
              </Grid>
              : null}

          </Grid>
        </div >
      ) : (
        'LOADING GRAPHIC'
      )
      }
    </>
  );
}

export default withTranslation()(LeftBar);
